import { NAME } from './constants';
import { router } from './router';
import Select from './components/Select.vue';

export const CheckIn = {
	name: NAME,
	router,
	components: {
		Select,
	},
};
